import React from "react";

export default function LayersPanel({ layers = [], activeLayerId, onSetActiveLayer, onUpdateLayer, onToggleSelectLayer, selectedLayerIds = [], onReleaseMask }) {
  return (
    <div className="flex flex-col h-full">
      <h3 className="font-semibold mb-3">Layers</h3>

      {/* Scrollable list area */}
      <div className="flex-1 overflow-auto space-y-2 pr-1">
        {layers.slice().reverse().length === 0 && (
          <div className="text-sm text-gray-500">No layers yet. Add a layer to get started.</div>
        )}

        {layers.slice().reverse().map((layer) => {
          const isSelected = selectedLayerIds.includes(layer.id);
          return (
            <div
              key={layer.id}
              className={`p-2 rounded border flex items-center justify-between ${layer.id === activeLayerId ? "bg-indigo-50" : "bg-white"} ${isSelected ? "ring-2 ring-indigo-300" : ""}`}
              onClick={(e) => {
                onSetActiveLayer(layer.id);
                if (onToggleSelectLayer) onToggleSelectLayer(layer.id, e);
              }}
            >
              <div>
                <div className="font-medium">{layer.name}{layer.isMaskSource ? " (mask)" : ""}</div>
                <div className="text-xs text-gray-500">{(layer.strokes || []).length} strokes</div>
              </div>
              <div className="flex items-center gap-2">
                {layer.mask && (
                <button
                  type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onReleaseMask) onReleaseMask(layer.id);
                    }}
                    className="px-2 py-1 border rounded text-sm"
                  >
                    Release Mask
                  </button>
                )}
                <button
                type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onUpdateLayer({ ...layer, visible: !layer.visible });
                  }}
                  className="px-2 py-1 border rounded text-sm"
                >
                  {layer.visible ? "Hide" : "Show"}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Footer helpful hint */}
      <div className="mt-3 text-xs text-gray-500">
        Tip: Shift/Ctrl+Click to multi-select layers. Use Mask to clip top layer to bottom.
      </div>
    </div>
  );
}

